import { render } from "./ProductComparisonComponent.vue?vue&type=template&id=b9ec880e&ts=true"
import script from "./ProductComparisonComponent.vue?vue&type=script&lang=ts"
export * from "./ProductComparisonComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\Website\\wwwroot\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__